module.exports = __webpack_public_path__ + "static/img/no_list.c7bc569.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/no_list.png
// module id = 7IpT
// module chunks = 0